import React from 'react';
import { NetworkCalculator } from './components/NetworkCalculator';

export const Netcalc: React.FC = () => {
  const handleCalculationSave = async (history: any) => {
    // Просто логируем для отладки
    console.log('Calculation performed:', history);
  };

  return (
    <div className="netcalc-app">
      <NetworkCalculator 
        onCalculationSave={handleCalculationSave}
        history={[]}
      />
    </div>
  );
};